import React, { Component } from 'react'
import MenuSider from '../../../../components/MenuSider'
import { Pie, Bar } from 'react-chartjs-2';
import { Constants, Odata_2_Url } from '../../../../Constants/Constants'
import { Select, Collapse, Button, Checkbox, Spin } from 'antd';
import { Col, Row } from 'react-bootstrap';
import '../Organization/Organization.css'
import './company.css'
import 'chartjs-plugin-labels';
import IntlMessages from '../../../../util/IntlMessages';


const Panel = Collapse.Panel;
const Option = Select.Option;

function formatNumber(num) {
	return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

const month_list = [{ "monthName": <IntlMessages id='January' />, "order": 1 },
{ "monthName": <IntlMessages id='February' />, "order": 2 },
{ "monthName": <IntlMessages id='March' />, "order": 3 },
{ "monthName": <IntlMessages id='April' />, "order": 4 },
{ "monthName": <IntlMessages id='May' />, "order": 5 },
{ "monthName": <IntlMessages id='June' />, "order": 6 },
{ "monthName": <IntlMessages id='July' />, "order": 7 },
{ "monthName": <IntlMessages id='August' />, "order": 8 },
{ "monthName": <IntlMessages id='September' />, "order": 9 },
{ "monthName": <IntlMessages id='October' />, "order": 10 },
{ "monthName": <IntlMessages id='November' />, "order": 11 },
{ "monthName": <IntlMessages id='December' />, "order": 12 }]

export default class Company extends Component {

	constructor(props) {
		super(props)

		this.handleChange = this.handleChange.bind(this);
		this.handleChangeChk_all = this.handleChangeChk_all.bind(this);
		this.handleChangeMonth = this.handleChangeMonth.bind(this);

		this.loadData = this.loadData.bind(this);

		let month_now = new Date().getMonth() + 1

		this.state = {
			companyData: [],
			companyValue: [],
			company_name: '',
			company_socard: '',
			company_target: '',
			percentSOTCompany: '',
			pieData: {},
			barData: {},
			barData_2: {},
			select_year: new Date().getFullYear(),
			select_month: [month_now],
			chkAll: false,
			onLoading: false,

			shown: 'none',
			shown2: 'none',
			barLabel: {
				scales: {
					yAxes: [{
						ticks: {
							beginAtZero: true,
						}
					}],
					xAxes: [{
						ticks: {
							autoSkip: false,
							autoSkipPadding: 20,
							maxRotation: 90,
							minRotation: 90
						},
						maxBarLength: 2,
						maxBarThinckness: 8,
					}]
				},
				plugins: {
					labels: {
						render: 'value'
					}
				}
			},
		}
	}

	componentDidUpdate(prevProps, prevState) {
		let stateEng = JSON.parse(window.localStorage.getItem('state'))
		let isEng = stateEng.setting.locale.locale == 'en'
		if (isEng !== prevState.isEng) {
			this.setState({ isEng: isEng })
			this.set_data_bar(this.state.safeData)
			this.set_data_bar_2(this.state.unSafeData)
			this.set_data(this.state.pieDataTemp.safeNumber, this.state.pieDataTemp.unSafeNumber)
		}
	}

	componentWillMount() {
		let state = JSON.parse(window.localStorage.getItem('state'))
		let isEng = state.setting.locale.locale == 'en'
		this.setState({ isEng: isEng })
		this.loadData();
	}

	set_data(safe, unsafe) {
		this.setState({
			pieData: {
				labels: this.state.isEng ? ['Safe', 'Unsafe'] : ['ปลอดภัย', 'ไม่ปลอดภัย'],
				datasets: [{
					data: [safe, unsafe],
					showInLegend: true,
					backgroundColor: [
						'rgba(75,220,150,0.5)',
						'rgba(255,99,132,0.5)',

					],
					borderColor: [
						'rgba(75,220,150,1)',
						'rgba(255,99,132,1)',

					],
					borderWidth: 0.2
				}]
			},
			pieLabel: {
				plugins: {
					labels: {
						render: function (args) {
							return args.label + ', ' + args.value + ', ' + args.percentage + '%';
						},
						fontSize: 14,
						fontStyle: 'bold'
					}
				}
			}
		})
	}

	set_data_bar(data) {
		var jobType = JSON.parse(window.localStorage.getItem('Jobtype'))
		let job_detail = data.map(l => {
			return this.state.isEng ? (jobType.find(x => x.JobType1.trim() === l.job_detail) || {}).Short_detail_EN : l.job_detail
		})
		this.setState({
			barData:
			{
				labels: job_detail,
				datasets: [
					{
						label: 'Number Of Safe',
						backgroundColor: 'rgba(75,220,150,0.2)',
						borderColor: 'rgba(75,220,150,1)',
						borderWidth: 1,
						data: [data[0].jobdetailNumber, data[1].jobdetailNumber, data[2].jobdetailNumber]
					}
				]
			}
		})
	}

	set_data_bar_2(data) {
		var jobType = JSON.parse(window.localStorage.getItem('Jobtype'))
		let job_detail = data.map(l => {
			return this.state.isEng ? (jobType.find(x => x.JobType1.trim() === l.job_detail) || {}).Short_detail_EN : l.job_detail
		})
		this.setState({
			barData_2:
			{
				labels: job_detail,
				datasets: [
					{
						label: 'Number Of UnSafe',
						backgroundColor: 'rgba(255,99,132,0.2)',
						borderColor: 'rgba(255,99,132,1)',
						borderWidth: 1,
						data: [data[0].jobdetailNumber, data[1].jobdetailNumber, data[2].jobdetailNumber]
					}
				]
			}
		})
	}

	handleChange(value) {
		this.setState({ select_year: value });
		this.bind_data();
	}

	handleChangeMonth(value) {
		this.setState({
			select_month: value
		})
	}

	handleChangeChk_all() {
		this.setState({ chkAll: !this.state.chkAll });
	};

	loadData() {
		this.setState({ onLoading: true });
		let select_month = this.state.chkAll ? 'all' : this.state.select_month;
		this.bind_data(select_month.toString());
	}



	bind_data(month) {

		const companyid = window.localStorage.getItem('CompanyID')
		const axios = require('axios');


		var Token
		axios.get(Constants.BASE_URL + 'auth/token')
			.then((response) => {
				Token = response.data
				// console.log(Token)

				axios.get(Odata_2_Url + 'v_CompanyReport?Year=' + this.state.select_year + "&Month=" + month + "&CompanyID=" + companyid,
					{
						headers: {
							"Authorization": "Bearer " + Token,
						}
					}
				).then((response) => {

					console.log(response);
					var data = []
					data = response.data

					if (data.length !== 0) {
						this.setState({ company_name: data[0].company_Name })
						this.setState({ company_socard: formatNumber(data[0].companySOCard) })
						this.setState({ company_target: formatNumber(data[0].companyTarget) })
						this.setState({ percentSOTCompany: formatNumber(data[0].percentSOTCompany) })

						this.set_data(data[0].safeNumber, data[0].unSafeNumber);

						this.setState({ shown: 'block', pieDataTemp: data[0] })
						this.setState({ shown2: 'block' })

						axios.get(Odata_2_Url + 'getTop3_company_rep?Year=' + this.state.select_year + "&Month=" + month + "&Company_name=" + data[0].company_Name,
							{
								headers: {
									"Authorization": "Bearer " + Token,
								}
							}
						).then((response) => {
							console.log(response);
							var data = []
							data = response.data
							if (data) {
								this.set_data_bar(data)
								this.setState({ safeData: data })
							}

						});

						axios.get(Odata_2_Url + 'getTop3_company_rep_unsafe?Year=' + this.state.select_year + "&Month=" + month + "&Company_name=" + data[0].company_Name,
							{
								headers: {
									"Authorization": "Bearer " + Token,
								}
							}
						).then((response) => {
							var data = []
							data = response.data
							this.set_data_bar_2(data)
							this.setState({ unSafeData: data })
						});
						this.setState({ onLoading: false });

					}
					else {

						this.setState({ shown: 'none' })
						this.setState({ shown2: 'none' })

						//alert("ไม่มีข้อมูลที่ท่านเลือก");
						this.setState({ onLoading: false });
					}
				},
					(error) => {
						this.setState({ onLoading: false });
						console.log(error)
					});
			},
				(error) => {
					this.setState({ onLoading: false });
					console.log(error)
					if (401 === error.response.status) {
						window.location.href = "auth";
					}
				});


	}


	render() {

		var min = "2018"
		var max = new Date().getFullYear()
		var options = []
		for (var i = min; i <= max; i++) {
			options.push(
				<Option value={i} key={i}>{i}</Option>
			)
		}

		let month_options = []
		month_list.map((l, i) => {
			month_options.push(
				<Option value={l.order} key={l.order}>{l.monthName}</Option>
			)
			return true
		})

		var hidden = {
			display: this.state.shown
		}
		var barCss = {
			display: this.state.shown,
			margin: '20px'
		}
		var show = {
			display: this.state.shown === 'none' ? 'block' : 'none',
			margin: '20px',
			textAlign: 'center'
		}

		return (

			<div className="col-12">
				<Spin spinning={this.state.onLoading} size="large" style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }} tip={<IntlMessages id='Loading' />}>
					<MenuSider title={<IntlMessages id='menu.dashboardCompany' />}>
						<div style={{ width: "100%", padding: "10px 20px 0 20px", textAlign: "center" }}>
							<Collapse defaultActiveKey={['1']}>
								<Panel header={<IntlMessages id='Filter' />} key="1">
									<div style={{ width: "100%", padding: "5px 20px 0 20px", textAlign: "center" }}>
										<div>
											<Row>
												<Checkbox
													defaultChecked={this.state.chkAll}
													onChange={this.handleChangeChk_all}
													style={{ margin: "10px 0px 10px 0px" }}
												>
													<IntlMessages id='All' />
												</Checkbox>
												<Select
													style={{ width: 220, margin: "10px 0px 10px 0px" }}
													placeholder="Select months"
													mode="multiple"
													onChange={this.handleChangeMonth} defaultValue={this.state.select_month}
													disabled={this.state.chkAll}
												>
													{month_options}
												</Select>
												&nbsp; &nbsp;
                                            {/* </Row>
                                            <Row> */}
												<Select style={{ width: 150, margin: "10px 0px 10px 0px" }} placeholder="Select a year"
													onChange={this.handleChange} defaultValue={max}>
													{options}
												</Select>
												&nbsp; &nbsp;
                                                <Button onClick={this.loadData} style={{ width: 120, margin: "10px 0px 10px 0px" }}><IntlMessages id='Search' /></Button>
											</Row>
										</div>
									</div>

								</Panel>
							</Collapse>
						</div>
						<div style={{ hidden }}>
							{
								this.state.company_name ? (
									<Row>
										<Col md xs style={{ textAlign: "center", margin: "20px" }}>
											<h4>{this.state.company_name}</h4>
										</Col>
									</Row>
								) : null
							}

							{
								this.state.company_socard ? (

									<Row>
										<Col md xs>
											<Col md="6" xs="6" style={{ textAlign: "right" }}>
												<h4>Company SO Card : </h4>
											</Col>
											<Col md="6" xs="6">

												<span> {this.state.company_socard}</span>

											</Col>
										</Col>
									</Row>
								) : null
							}


							{
								this.state.company_target ? (
									<Row>
										<Col md xs>
											<Col md="6" xs="6" style={{ textAlign: "right" }}>
												<h4>Company Target : </h4>
											</Col>
											<Col md="6" xs="6">
												<span> {this.state.company_target}</span>
											</Col>
										</Col>
									</Row>
								) : null
							}


							{
								this.state.percentSOTCompany ? (
									<Row>
										<Col md xs>
											<Col md="6" xs="6" style={{ textAlign: "right" }}>
												<h4>% SOT : </h4>
											</Col>
											<Col md="6" xs="6">
												<span> {this.state.percentSOTCompany} % </span>
											</Col>
										</Col>
									</Row>
								) : null
							}
						</div>
						<div style={show}>
							<span><IntlMessages id='Dashboard.NodataAvailable' /></span>
						</div>
						<div style={barCss}>

							<div className="col-12 web">

								<div className="col-12">
									<div className="col-7" style={{ textAlign: "center", paddingBottom: "3%" }}>
										<div className="col-12">
											<p style={{ textAlign: "center", fontSize: "18px", marginTop: "15px" }}>Summary safe unsafe of safety obervation tour</p>
											<Pie style={{ marginTop: "20px" }} data={this.state.pieData} options={this.state.pieLabel} />
										</div>
									</div>
								</div>

								<div className="col-12">
									<div className="col-5" style={{ textAlign: "center", padding: "3%", paddingLeft: "0px", paddingBottom: "3%" }}>
										<div className="col-12">
											<p style={{ textAlign: "center", fontSize: "18px" }}>Summary Top 3 Safe of Job</p>
											<Bar style={{ marginTop: "20px" }} data={this.state.barData} options={this.state.barLabel} />
										</div>
									</div>
									<div className="col-5" style={{ textAlign: "center", padding: "3%", paddingLeft: "0px", paddingBottom: "3%" }}>
										<div className="col-12">
											<p style={{ textAlign: "center", fontSize: "18px" }}>Summary Top 3 UnSafe of Job</p>
											<Bar style={{ marginTop: "20px" }} data={this.state.barData_2} options={this.state.barLabel} />
										</div>
									</div>
								</div>

							</div>

						</div>
					</MenuSider>
				</Spin>
			</div>

		)

	}
}